import React from "react";

export default function Math_Tensors() {
  return (
    <div>
      <h1>Math_Tensors</h1>
      <p>This is the Math_Tensors component.</p>
    </div>
  );
}
